import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';

const FooterSection = styled.div`
  padding-bottom: ${ndsTokens.space.generic.x2};
  border-bottom: 1px solid ${ndsTokens.colors.palette.white};
  margin-bottom: ${ndsTokens.space.generic.x3};
`;

export { FooterSection };
